import { useCallback, useMemo } from "react";
import {
  parseStoredWidgetLayout,
  type StoredWidgetLayout,
} from "@heraion/shared";

import type { UseProfileDoc } from "./useProfileDoc";

// HR-11, PG-57: a widget surface's layout props on web. Reads and writes the
// profile doc the screen already holds (no second fetch). Twin of
// apps/mobile/src/screens/useHomeLayoutProps.ts.
function useStoredLayout(
  field: "homeLayout" | "progressLayout",
  doc: UseProfileDoc["doc"],
  savePatch: UseProfileDoc["savePatch"],
) {
  const stored = useMemo(() => parseStoredWidgetLayout(doc?.[field]), [doc, field]);
  const save = useCallback(
    (next: StoredWidgetLayout | undefined) => savePatch({ [field]: next }),
    [savePatch, field],
  );
  return { stored, save };
}

export function useHomeLayoutProps(
  doc: UseProfileDoc["doc"],
  savePatch: UseProfileDoc["savePatch"],
) {
  const { stored, save } = useStoredLayout("homeLayout", doc, savePatch);
  return { homeLayout: stored, onSaveHomeLayout: save };
}

export function useProgressLayoutProps(
  doc: UseProfileDoc["doc"],
  savePatch: UseProfileDoc["savePatch"],
) {
  const { stored, save } = useStoredLayout("progressLayout", doc, savePatch);
  return { progressLayout: stored, onSaveProgressLayout: save };
}
